import LogoNegative from "../frontend/assets/logo-negative.svg";
import LogoNegativeOmsorg from "../frontend/assets/logo-negative-omsorg.svg";
import EmailForm from "../EmailForm/EmailForm";

interface Link {
  title?: string;
  url?: string;
  type?: string;
}

interface SocialMedia {
  url?: string;
  title: string;
  link: string;
  icon?: string;
  code?: string;
}

interface FooterProps {
  phone: string;

  mapLinkTitle: string;
  mapLinkUrl: string;
  mapLinkType: string;

  showSubscribeForm: boolean;
  privacyLinkSubscribeFormUrl: string;
  subscriptionLinkSubscribeFormUrl: string;

  titleContactUsLinks: string;
  contactUsLinks: Link[];
  titleAboutUsLinks: string;
  aboutUsLinks: Link[];

  socialMedia: SocialMedia[];

  linkYellowUrl: string;
  linkYellowTitle: string;
  linkYellowType: string;
  linkYellowShow: boolean;

  linkDiakonhjemmetHageUrl: string;
  linkDiakonhjemmetHageTitle: string;
  linkDiakonhjemmetHageType: string;
  linkDiakonhjemmetHageShow: boolean;

  thema: string;
}

const Footer: React.FC<FooterProps> = ({
  phone,

  mapLinkTitle,
  mapLinkUrl,
  mapLinkType,

  showSubscribeForm,
  privacyLinkSubscribeFormUrl,
  subscriptionLinkSubscribeFormUrl,
  titleContactUsLinks,
  contactUsLinks,
  titleAboutUsLinks,
  aboutUsLinks,
  socialMedia,

  linkYellowUrl,
  linkYellowTitle,
  linkYellowType,
  linkYellowShow,

  linkDiakonhjemmetHageUrl,
  linkDiakonhjemmetHageTitle,
  linkDiakonhjemmetHageType,
  linkDiakonhjemmetHageShow,

  thema,
}) => {
  let targetMapLink = "";
  if (mapLinkType == "external") {
    targetMapLink = "_blank";
  }

  let targetlinkYellow = "";
  if (linkYellowType == "external") {
    targetlinkYellow = "_blank";
  }

  let targetlinkDiakonhjemmetHage = "";
  if (linkDiakonhjemmetHageType == "external") {
    targetlinkDiakonhjemmetHage = "_blank";
  }

  return (
    <footer className="site-footer">
      {linkDiakonhjemmetHageShow && (
        <a
          className="garden-cta-btn"
          href={linkDiakonhjemmetHageUrl}
          target={targetlinkDiakonhjemmetHage}
        >
          {linkDiakonhjemmetHageTitle}
        </a>
      )}

      {linkYellowShow && (
        <a
          className="footer-cta-btn"
          href={linkYellowUrl}
          target={targetlinkYellow}
        >
          {linkYellowTitle}
        </a>
      )}
      <div className="footer-top">
        <nav>
          <h2>{titleContactUsLinks}</h2>
          <ul>
            {contactUsLinks.map((contact, idx) => (
              <li key={idx}>
                <a
                  href={contact.url}
                  target={contact.type === "external" ? "_blank" : undefined}
                  rel={contact.type === "external" ? "noreferrer" : undefined}
                >
                  {contact.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <nav>
          <h2>{titleAboutUsLinks}</h2>
          <ul>
            {aboutUsLinks.map((item, idx) => (
              <li key={idx}>
                <a
                  href={item.url}
                  target={item.type === "external" ? "_blank" : undefined}
                  rel={item.type === "external" ? "noreferrer" : undefined}
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        {showSubscribeForm && (
          <EmailForm
            privacyUrl={privacyLinkSubscribeFormUrl}
            subscriptionUrl={subscriptionLinkSubscribeFormUrl}
          />
        )}
      </div>

      <div className="footer-bottom">
        <div>
          <a href="/" aria-label="Forside" className="footerLogo">
            {thema == "diakonhjemmet" && <LogoNegative />}
            {thema == "diakonhjemmetOmsorg" && <LogoNegativeOmsorg />}
          </a>
        </div>
        <div>{phone}</div>
        <div>
          <a href={mapLinkUrl} target={targetMapLink}>
            {mapLinkTitle}
          </a>
        </div>
        <div>
          {socialMedia.map((item, idx) => (
            <a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              aria-label={item.title}
              dangerouslySetInnerHTML={{ __html: item.code }}
              key={idx}
            />
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
